export default __webpack_public_path__ + "static/media/glover-banner.8edaed6f.png";